import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import SEOHead from '@/components/base/SEOHead';
import HeroSection from '@/pages/home/components/HeroSection';
import CategorySection from '@/pages/home/components/CategorySection';
import AdvantageSection from '@/pages/home/components/AdvantageSection';
import CaseSection from '@/pages/home/components/CaseSection';
import FAQSection from '@/pages/home/components/FAQSection';
import CTASection from '@/pages/home/components/CTASection';

const jsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      '@id': 'https://www.jiujiucao.com/#organization',
      name: '久久草',
      url: 'https://www.jiujiucao.com',
      description: '久久草——品质保证，正品直达。专业草坪草皮、草种及绿化解决方案提供商。',
      telephone: '+86-400-888-9999',
      email: 'contact@jiujiucao.com',
      address: {
        '@type': 'PostalAddress',
        streetAddress: '绿化路88号久久草大厦',
        addressLocality: '北京',
        addressRegion: '朝阳区',
        addressCountry: 'CN',
      },
      openingHoursSpecification: {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
        opens: '08:00',
        closes: '18:00',
      },
    },
    {
      '@type': 'WebSite',
      '@id': 'https://www.jiujiucao.com/#website',
      url: 'https://www.jiujiucao.com',
      name: '久久草',
      description: '久久草——品质保证，正品直达 | 优质草坪草皮、草种及绿化解决方案',
      publisher: {
        '@id': 'https://www.jiujiucao.com/#organization',
      },
      inLanguage: 'zh-CN',
    },
    {
      '@type': 'WebPage',
      '@id': 'https://www.jiujiucao.com/#webpage',
      url: 'https://www.jiujiucao.com',
      name: '久久草首页',
      description: '久久草——品质保证，正品直达。为您提供优质草坪草皮、草种及绿化解决方案。',
      isPartOf: {
        '@id': 'https://www.jiujiucao.com/#website',
      },
      about: {
        '@id': 'https://www.jiujiucao.com/#organization',
      },
      inLanguage: 'zh-CN',
    },
    {
      '@type': 'FAQPage',
      '@id': 'https://www.jiujiucao.com/#faq',
      mainEntity: [
        {
          '@type': 'Question',
          name: '久久草的草皮品种主要有哪些？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '久久草主要提供百慕大草（狗牙根）、结缕草（马尼拉草）、高羊茅、黑麦草、早熟禾等多个品种。不同品种适用于不同的气候环境和用途。',
          },
        },
        {
          '@type': 'Question',
          name: '草皮铺设后多久可以正常使用？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '一般情况下，久久草草皮铺设后2-3周即可生根固定，4-6周后可正常使用。',
          },
        },
        {
          '@type': 'Question',
          name: '久久草的产品价格如何？怎么获取报价？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '久久草产品价格根据品种、规格、数量及距离等因素有所不同。您可以通过官网在线咨询、拨打客服热线或直接访问线下门店获取最新报价。',
          },
        },
        {
          '@type': 'Question',
          name: '久久草支持全国发货吗？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '久久草目前支持全国主要城市配送，采用专业保鲜运输方式。从收割到送达不超过24小时。',
          },
        },
      ],
    },
  ],
};

export default function Home() {
  return (
    <>
      <SEOHead
        title="久久草——品质保证，正品直达 | 优质草坪草皮、草种及绿化解决方案"
        description="久久草，为您提供优质草坪草皮、草种及绿化解决方案。久久草精选优良品种，适用于庭院、运动场、园林绿化等多种场景，品质经久耐用，服务专业可靠，立即了解久久草全系产品与报价。"
        keywords="久久草,久久草草坪,久久草草皮,久久草草种,久久草绿化,久久草庭院草坪,久久草园林"
        canonicalUrl="https://www.jiujiucao.com/"
        jsonLd={jsonLd}
      />

      <Navbar />

      <main>
        <HeroSection />
        <CategorySection />
        <AdvantageSection />
        <CaseSection />
        <FAQSection />
        <CTASection />
      </main>

      <Footer />
      <ScrollToTop />
    </>
  );
}